export const FLASHCARDS = [
  {
    "id": 1,
    "topic_id": 4,
    "title": "What are the three main approaches to machine learning?",
    "description": "Supervised, unsupervised, and reinforcement learning."
  },
  {
    "id": 2,
    "topic_id": 4,
    "title": "What does the DAMA framework focus on?",
    "description": "Data governance and stewardship."
  },
  {
    "id": 3,
    "topic_id": 3,
    "title": "_____ is the practice of writing code that is understandable, error-free, and easy to maintain.",
    "description": "Clean code methods."
  },
  {
    "id": 4,
    "topic_id": 1,
    "title": "True/False: Artificial intelligence and machine learning are different names for the same concept.",
    "description": "False. Artificial intelligence is the practice of creating machines that mimic human behavior, while machine learning is a technique that can be used by AI."
  },
  {
    "id": 5,
    "topic_id": 1,
    "title": "What are the phases of the CRISP-DM framework?",
    "description": "Business Understanding, Data Understanding, Data Preparation, Modeling, Evaluation, and Deployment."
  },
  {
    "id": 6,
    "topic_id": 1,
    "title": "What is dependency licensing used for in a data science project?",
    "description": "Ensuring compliance with the legal terms under which software libraries and components (dependencies of a project) can be used, modified, and redistributed."
  },
  {
    "id": 7,
    "topic_id": 1,
    "title": "_____ is a field of data science that allows machines to understand and generate human language.",
    "description": "Natural language processing."
  },
  {
    "id": 8,
    "topic_id": 4,
    "title": "_____ is a field of data science that attempts to find the best solution to a problem given a set of constraints.",
    "description": "Optimization."
  },
  {
    "id": 9,
    "topic_id": 4,
    "title": "True/False: The majority of time in a data science project is usually spent building models.",
    "description": "False. Usually, the majority of the time is spent on data cleaning and processing."
  },
  {
    "id": 10,
    "topic_id": 4,
    "title": "What is the purpose of signal processing in machine learning?",
    "description": "To process, analyze, and create sound, image, video, and audio signals."
  },
  {
    "id": 11,
    "topic_id": 2,
    "title": "The calculus technique used to calculate the derivate of a composite function is called the _____ .",
    "description": "Chain rule."
  },
  {
    "id": 12,
    "topic_id": 1,
    "title": "In a statistical study, what is the group of interest that one is intending to draw conclusions about called?",
    "description": "Population."
  },
  {
    "id": 13,
    "topic_id": 4,
    "title": "What are some common continuous probability distributions?",
    "description": "Normal (Gaussian), Continuous Uniform, t (Student\u2019s t) distribution, and Power Law (Pareto)."
  },
  {
    "id": 14,
    "topic_id": 4,
    "title": "What are some common discrete probability distributions?",
    "description": "Discrete uniform, Poisson, and Binomial."
  },
  {
    "id": 15,
    "topic_id": 4,
    "title": "True/False: The central limit theorem (CLT) states that regardless of the probability distribution of the population, for a small enough sample size, the sampling distribution will always be normally distributed.",
    "description": "False; CLT suggests that the sampling distribution will always be normally distributed if the sample size is large enough."
  },
  {
    "id": 16,
    "topic_id": 1,
    "title": "True/False: The most common type of interval estimate is the confidence interval.",
    "description": "True; a confidence interval is the most common type of interval estimate, as it provides a range of values where one would expect the true value of a population to lie."
  },
  {
    "id": 17,
    "topic_id": 2,
    "title": "What is a formal statistical method used to compare populations or assess relationships between variables based on sample data?",
    "description": "Hypothesis testing."
  },
  {
    "id": 18,
    "topic_id": 3,
    "title": "What are the kinds of t-tests?",
    "description": "One-sample t-test, two-sample t-test, and paired-sample t-test."
  },
  {
    "id": 19,
    "topic_id": 2,
    "title": "What are two common kinds of correlation tests?",
    "description": "Pearson\u2019s correlation coefficient and Spearman\u2019s rank correlation coefficient."
  },
  {
    "id": 20,
    "topic_id": 4,
    "title": "A slightly more complicated approach to vector multiplication is known as the _____.",
    "description": "Dot product."
  },
  {
    "id": 21,
    "topic_id": 4,
    "title": "True/False: Data sources can be broadly categorized into artificial data, synthetic data, and commercial or public data.",
    "description": "False. The three broad categories for data sources are generated data, synthetic data, and commercial or public data. Artificial data is synonymous with synthetic data."
  },
  {
    "id": 22,
    "topic_id": 3,
    "title": "The process of importing, processing, and storing data for later use is called _____.",
    "description": "Data ingestion."
  },
  {
    "id": 23,
    "topic_id": 3,
    "title": "What are the two main methods of data ingestion?",
    "description": "Streaming and batching."
  },
  {
    "id": 24,
    "topic_id": 3,
    "title": "True/False: GPUs and TPUs provide key advantages during the data ingestion process with parallel processing and resource isolation.",
    "description": "True. GPUs and TPUs excel at handling multiple computational tasks simultaneously and offer the benefit of resource isolation."
  },
  {
    "id": 25,
    "topic_id": 3,
    "title": "What are the components of the ETL process?",
    "description": "Extract, Transform, and Load."
  },
  {
    "id": 26,
    "topic_id": 3,
    "title": "Storage systems that accommodate data without a specific schema or predefined structure are known as _____.",
    "description": "Unstructured storage systems."
  },
  {
    "id": 27,
    "topic_id": 3,
    "title": "True/False: A JSON file is an example of a kind of structured storage format.",
    "description": "False: A JSON file is an example of a semi-structured storage format."
  },
  {
    "id": 28,
    "topic_id": 3,
    "title": "The regular and scheduled process of updating data to ensure it remains current, accurate, and relevant is a _____.",
    "description": "Refresh cycle."
  },
  {
    "id": 29,
    "topic_id": 3,
    "title": "What is archiving?",
    "description": "Archiving is the process of moving older data that may no longer be in active use (but needs to be retained for various reasons) to long-term storage."
  },
  {
    "id": 30,
    "topic_id": 3,
    "title": "True/False: The weekly payroll of a company is an example of administrative data.",
    "description": "True: Administrative data consists of data that is generated internally within a company/organization\u2019s normal operations. The weekly payroll of a company is internally generated from the company during the normal course of its operations."
  },
  {
    "id": 31,
    "topic_id": 5,
    "title": "True/False: A stationary time series may exhibit seasonality.",
    "description": "False. Stationarity assumes that the mean and variance of the time series is constant over time, which is not true if seasonality exists."
  },
  {
    "id": 32,
    "topic_id": 5,
    "title": "A ______ is a graphical representation of a variable\u2019s distribution that includes minimum, first quartile, median, third quartile, and maximum.",
    "description": "Box and whisker plot."
  },
  {
    "id": 33,
    "topic_id": 5,
    "title": "What are the three main types of issues common in data?",
    "description": "Structural, temporal, and completeness issues."
  },
  {
    "id": 34,
    "topic_id": 1,
    "title": "True/False: Correlation plots can be useful in both bivariate and multivariate analysis.",
    "description": "True. Correlation plots show the relationship between a pair of variables but can simultaneously show the correlations between all variables in a dataset."
  },
  {
    "id": 35,
    "topic_id": 5,
    "title": "What does a Sankey diagram show?",
    "description": "The flow of data between different categories, including the magnitude and direction of the data."
  },
  {
    "id": 36,
    "topic_id": 5,
    "title": "_________ is a multivariate technique that groups similar observations based on certain attributes.",
    "description": "Clustering or cluster analysis."
  },
  {
    "id": 37,
    "topic_id": 2,
    "title": "True/False: Outliers should never be removed from a dataset.",
    "description": "False. If the outliers do not contain valuable information, or if they significantly impact the analysis, it may be best to remove them."
  },
  {
    "id": 38,
    "topic_id": 2,
    "title": "What are the three categories of missing data?",
    "description": "Missing Completely at Random (MCAR), Missing at Random (MAR), and Missing Not at Random (MNAR)."
  },
  {
    "id": 39,
    "topic_id": 3,
    "title": "What is Principal Component Analysis (PCA)?",
    "description": "A dimensionality reduction technique that involves transforming a large set of variables into a smaller one that still contains most of the information in the large set."
  },
  {
    "id": 40,
    "topic_id": 1,
    "title": "Is a variable that holds gender values a nominal or an ordinal variable?",
    "description": "Nominal. There is no natural hierarchy or order to the categories."
  },
  {
    "id": 41,
    "topic_id": 3,
    "title": "True/False: Encoding is the process of transforming numerical data into a categorical form to make it more suitable for certain analytic models.",
    "description": "False. Encoding is the process of transforming categorical data into numerical form to make it more suitable for certain analytic models."
  },
  {
    "id": 42,
    "topic_id": 4,
    "title": "_____ is the process of making the scale of different features more compatible and consistent.",
    "description": "Scaling/Normalization."
  },
  {
    "id": 43,
    "topic_id": 4,
    "title": "What are two commonly used transformation techniques?",
    "description": "Log transformation and Box-Cox techniques."
  },
  {
    "id": 44,
    "topic_id": 2,
    "title": "True/False: Pivoting data can allow for relationships and trends to become more visible.",
    "description": "True. Pivoting can make data easier to compare and it can also enhance visualization."
  },
  {
    "id": 45,
    "topic_id": 3,
    "title": "What are three feature extraction techniques?",
    "description": "Principal Component Analysis (PCA), Linear Discriminant Analysis (LDA), and Independent Component Analysis (ICA)."
  },
  {
    "id": 46,
    "topic_id": 4,
    "title": "The operation that combines two or more datasets (or tables) vertically is known as a _____.",
    "description": "Union."
  },
  {
    "id": 47,
    "topic_id": 2,
    "title": "True/False: Mistyping a data value into a spreadsheet is an example of a systematic error.",
    "description": "False: This is an example of an idiosyncratic error."
  },
  {
    "id": 48,
    "topic_id": 2,
    "title": "The process of creating an additional column to tag records with missing values is known as _____.",
    "description": "Flagging."
  },
  {
    "id": 49,
    "topic_id": 2,
    "title": "What is imputation?",
    "description": "Imputation is the process of replacing missing, incomplete, or erroneous data with substituted values to maintain the integrity and completeness of a dataset."
  },
  {
    "id": 50,
    "topic_id": 3,
    "title": "True/False: Accuracy is always the best metric to use when evaluating the performance of a model.",
    "description": "False: Due to the accuracy paradox, other metrics should also be considered when evaluating the performance of a model."
  },
  {
    "id": 51,
    "topic_id": 3,
    "title": "Regression models predict a _____ variable, whereas classification models predict a _____ variable.",
    "description": "Continuous; categorical."
  },
  {
    "id": 52,
    "topic_id": 1,
    "title": "What do autoregressive models base their predictions on?",
    "description": "A linear combination of the previous values of the time series."
  },
  {
    "id": 53,
    "topic_id": 1,
    "title": "True/False: Longitudinal studies are used to derive insights about a population at a point in time.",
    "description": "False. Longitudinal studies are repeated over a long period of time and provide insights about change and continuity."
  },
  {
    "id": 54,
    "topic_id": 1,
    "title": "How does A/B testing work?",
    "description": "Participants are placed randomly into one of two groups and given different treatments to compare the treatments\u2019 effects."
  },
  {
    "id": 55,
    "topic_id": 3,
    "title": "The process of partitioning data into training and test sets prior to model build is known as the _____ method.",
    "description": "Holdout."
  },
  {
    "id": 56,
    "topic_id": 3,
    "title": "A _______ is a parameter whose value is set before the learning process begins and controls the behavior of the training algorithm or model, such as the learning rate, number of clusters, or depth of a decision tree.",
    "description": "Hyperparameter."
  },
  {
    "id": 57,
    "topic_id": 1,
    "title": "What is the main difference between AIC (Akaike Information Criterion) and BIC (Bayesian Information Criterion) in evaluating models?",
    "description": "BIC penalizes models with more parameters, so it favors simpler models."
  },
  {
    "id": 58,
    "topic_id": 3,
    "title": "How is precision calculated for a model?",
    "description": "Precision is the number of true positives divided by the sum of true positives and false positives."
  },
  {
    "id": 59,
    "topic_id": 3,
    "title": "True/False: A model with an AUC (Area Under the Curve) close to 1 is considered a strong classifier.",
    "description": "True. AUC values fall between 0.5 and 1.0. A random predictor would have an AUC of 0.5, while a perfect predictor would have an AUC of 1."
  },
  {
    "id": 60,
    "topic_id": 1,
    "title": "________ is a statistical resampling technique that involves repeatedly sampling with replacement from a dataset to improve the accuracy of estimates or predictions.",
    "description": "Bootstrapping."
  },
  {
    "id": 61,
    "topic_id": 3,
    "title": "True/False: An ROC (Receiver Operating Characteristic) curve is the same thing as a precision-recall curve and is essential for understanding the performance of classification models.",
    "description": "False. Although an ROC curve is essential for understanding the performance of classification models, it is not the same thing as a precision-recall curve."
  },
  {
    "id": 62,
    "topic_id": 4,
    "title": "_______ is the process of creating virtual versions of physical computing resources, such as servers, storage devices, and networks, to optimize resource utilization and management.",
    "description": "Virtualization."
  },
  {
    "id": 63,
    "topic_id": 2,
    "title": "________ occurs when the statistical properties of the target variable change over time, causing a model\u2019s performance to degrade as the data distribution shifts.",
    "description": "Concept drift."
  },
  {
    "id": 64,
    "topic_id": 2,
    "title": "______ is the change in the statistical properties of input data over time, which can lead to decreased model performance as the data the model was trained on no longer represents the current data.",
    "description": "Data drift."
  },
  {
    "id": 65,
    "topic_id": 4,
    "title": "True/False: Hybrid deployment is a combination of cloud deployment and on-premises deployment.",
    "description": "True. Hybrid deployment combines cloud and on-premises deployment to leverage the benefits of both."
  },
  {
    "id": 66,
    "topic_id": 4,
    "title": "What are the components of MLOps?",
    "description": "Automation, versioning, testing, and monitoring."
  },
  {
    "id": 67,
    "topic_id": 2,
    "title": "The phase in the data science life cycle where the performance and effectiveness of a model are rigorously evaluated to ensure it meets design specifications, satisfies requirements, and is standards-compliant prior to deployment is known as ______.",
    "description": "Model validation."
  },
  {
    "id": 68,
    "topic_id": 2,
    "title": "True/False: A residual plot is used to assess trends, as well as the seasonal and residual components of a dataset.",
    "description": "False: A residual plot is used to assess the goodness of fit of a regression model."
  },
  {
    "id": 69,
    "topic_id": 2,
    "title": "Objectively evaluating a model\u2019s performance and its practical utility in comparison to existing standards or methods is known as ______.",
    "description": "Benchmarking."
  },
  {
    "id": 70,
    "topic_id": 4,
    "title": "What is a data dictionary?",
    "description": "A data dictionary is a detailed description of each data element within your dataset."
  },
  {
    "id": 71,
    "topic_id": 2,
    "title": "True/False: The way results of a model are communicated differ depending on who the intended stakeholder is.",
    "description": "True: Adapting the depth and complexity of communication to suit different audiences is essential for effective communication of model insights."
  },
  {
    "id": 72,
    "topic_id": 3,
    "title": "If an association rule does not provide any meaningful new insights, it is referred to as a _____ rule.",
    "description": "Trivial."
  },
  {
    "id": 73,
    "topic_id": 3,
    "title": "Which metric represents how often an association rule occurs in a dataset?",
    "description": "Support."
  },
  {
    "id": 74,
    "topic_id": 3,
    "title": "True/False: k-Means clustering is not effective at creating nonspherical clusters.",
    "description": "True. k-Means clustering can only create spherical clusters."
  },
  {
    "id": 75,
    "topic_id": 3,
    "title": "What are the three main categories of clustering?",
    "description": "Centroid-based, connectivity-based, and density-based clustering."
  },
  {
    "id": 76,
    "topic_id": 3,
    "title": "What is the average silhouette method used for?",
    "description": "Determining the optimal number of clusters."
  },
  {
    "id": 77,
    "topic_id": 3,
    "title": "Are t-SNE and UMAP linear or nonlinear dimensionality reduction techniques?",
    "description": "They are nonlinear, meaning that they can capture nonlinear relationships among the features of a dataset."
  },
  {
    "id": 78,
    "topic_id": 3,
    "title": "True/False: Feature extraction results in a higher dimensional dataset, whereas feature selection results in lower dimensions.",
    "description": "False. Both feature selection and feature extraction are dimensionality reduction techniques."
  },
  {
    "id": 79,
    "topic_id": 3,
    "title": "What is the difference between memory-based and model-based collaborative filtering?",
    "description": "Memory-based collaborative filtering makes recommendations based on user or item similarities within the entire dataset, whereas model-based collaborative filtering uses machine learning models to predict user preferences and to make recommendations."
  },
  {
    "id": 80,
    "topic_id": 2,
    "title": "When recommender systems have very little data on users and items, they may suffer from the ______ problem.",
    "description": "Cold start."
  },
  {
    "id": 81,
    "topic_id": 3,
    "title": "True/False: Collaborative filtering and content-based filtering can be used together on a single recommender system.",
    "description": "True. Collaborative filtering and content-based filtering can be combined to create a hybrid recommender system, leveraging the strengths of both methods to improve recommendation accuracy and mitigate the limitations of each approach."
  },
  {
    "id": 82,
    "topic_id": 3,
    "title": "Some of the assumptions made about the data by the ordinary least squares method include _______.",
    "description": "Linearity, independence, homoscedasticity, normality, and little to no multicollinearity."
  },
  {
    "id": 83,
    "topic_id": 3,
    "title": "The three types of ensembles are _____.",
    "description": "Bagging, boosting, and stacking ensembles."
  },
  {
    "id": 84,
    "topic_id": 1,
    "title": "True/False: The Shapiro-Wilk test can help assess homoscedasticity in a dataset.",
    "description": "False. The Shapiro-Wilk test can help assess normality."
  },
  {
    "id": 85,
    "topic_id": 3,
    "title": "______ is a statistical modeling technique that enables linear regression models to generalize well to unseen data.",
    "description": "Regularization."
  },
  {
    "id": 86,
    "topic_id": 3,
    "title": "What are the two types of discriminant analysis?",
    "description": "Linear and quadratic discriminant analysis."
  },
  {
    "id": 87,
    "topic_id": 3,
    "title": "True/False: Decision trees suffer from the \u201cZero Frequency\u201d problem.",
    "description": "False. The Na\u00efve Bayes algorithm suffers from the \u201cZero Frequency\u201d problem."
  },
  {
    "id": 88,
    "topic_id": 3,
    "title": "An _________ is a supervised machine learning technique that combines multiple models to improve overall performance and robustness compared to individual models.",
    "description": "Ensemble."
  },
  {
    "id": 89,
    "topic_id": 3,
    "title": "True/False: LASSO, Ridge, and ElasticNet are regularization techniques.",
    "description": "True. LASSO is also known as L1 Regularization, and Ridge is also known as L2 Regularization. ElasticNet combines both L1 and L2 penalties in its regularization approach."
  },
  {
    "id": 90,
    "topic_id": 3,
    "title": "A supervised machine learning approach where the primary objective is to identify the class to which a new observation belongs to is called _____.",
    "description": "Classification."
  },
  {
    "id": 91,
    "topic_id": 3,
    "title": "What is discriminant analysis?",
    "description": "Discriminant analysis is a statistical technique used to classify observations into predefined categories by finding a combination of features that best separates the classes."
  },
  {
    "id": 92,
    "topic_id": 3,
    "title": "What are the three types of layers in a neural network?",
    "description": "Input, hidden, and output layers."
  },
  {
    "id": 93,
    "topic_id": 3,
    "title": "What is the potential range of outputs for the sigmoid activation function?",
    "description": "Any real number between 0 and 1."
  },
  {
    "id": 94,
    "topic_id": 3,
    "title": "_________ is a training algorithm for artificial neural networks that involves propagating the error backward through the network to update the weights and minimize the difference between the predicted and actual outputs.",
    "description": "Backpropagation."
  },
  {
    "id": 95,
    "topic_id": 3,
    "title": "What is few-shot learning?",
    "description": "Few-shot learning is a machine learning approach that enables models to generalize and make accurate predictions from only a few training examples."
  },
  {
    "id": 96,
    "topic_id": 3,
    "title": "True/False: Recurrent neural networks (RNNs) are effective at handling large amounts of text.",
    "description": "False. While RNNs are designed to handle sequential data, the vanishing gradient problem makes it difficult for them to handle long sequences of data."
  },
  {
    "id": 97,
    "topic_id": 3,
    "title": "What type of machine learning framework automates model development tasks, making it more accessible to nonexperts?",
    "description": "Automated Machine Learning (AutoML)."
  },
  {
    "id": 98,
    "topic_id": 3,
    "title": "What are generative adversarial networks (GANs) used for?",
    "description": "GANs create realistic images, audio, text, and video."
  },
  {
    "id": 99,
    "topic_id": 5,
    "title": "True/False: Increasing a model\u2019s learning rate will increase the chances of finding the optimal solution.",
    "description": "False. Increasing learning rate will train the model faster but increases the chance the model will miss the optimal solution."
  },
  {
    "id": 100,
    "topic_id": 3,
    "title": "Which neural network architecture uses a gating mechanism that allows it to handle larger sequences of data?",
    "description": "Long Short-Term Memory (LSTM) and Gated Recurrent Unit (GRU) networks."
  },
  {
    "id": 101,
    "topic_id": 3,
    "title": "Which neural network architecture finds efficient and compact encodings of the input data?",
    "description": "Autoencoders."
  },
  {
    "id": 102,
    "topic_id": 5,
    "title": "The ___________ approach to sentiment analysis involves using a predefined dictionary of words associated with positive and negative sentiments to analyze the sentiment of a text by counting and aggregating the sentiment scores of the words present in the text.",
    "description": "lexicon-based."
  },
  {
    "id": 103,
    "topic_id": 5,
    "title": "The two broad categories of matching models are _______.",
    "description": "String matching and semantic matching."
  },
  {
    "id": 104,
    "topic_id": 3,
    "title": "True/False: The Latent Dirichlet Allocation (LDA) algorithm is commonly used for text preparation.",
    "description": "False. The LDA algorithm is commonly used for topic modeling."
  },
  {
    "id": 105,
    "topic_id": 5,
    "title": "Syntax analysis, semantic analysis, and named entity recognition are key components of _________..",
    "description": "language understanding."
  },
  {
    "id": 106,
    "topic_id": 5,
    "title": "What are the two common ways to reduce a word to its base form?",
    "description": "Stemming and lemmatization."
  },
  {
    "id": 107,
    "topic_id": 5,
    "title": "True/False: Removing stop words means removing the most meaningful words in a corpus.",
    "description": "False. Removing stop words means removing words that occur a lot but have very little analytic impact."
  },
  {
    "id": 108,
    "topic_id": 5,
    "title": "The process of correcting spelling mistakes and eliminating variations in spelling is known as ________.",
    "description": "Spelling normalization."
  },
  {
    "id": 109,
    "topic_id": 5,
    "title": "True/False: Edit distance is a kind of fuzzy matching algorithm.",
    "description": "True. Edit distance is a common fuzzy matching algorithm for spelling normalization."
  },
  {
    "id": 110,
    "topic_id": 2,
    "title": "Techniques or tools used to enhance or generate additional training data from existing text data by applying transformations that preserve the meaning of the text but alter its phrasing or structure are known as _________.",
    "description": "Augmenters."
  },
  {
    "id": 111,
    "topic_id": 5,
    "title": "What does text representation involve?",
    "description": "Text representation involves converting unstructured text into a structured format that machines can understand and use to decode patterns within a language."
  },
  {
    "id": 112,
    "topic_id": 5,
    "title": "What does the objective function represent in an optimization problem?",
    "description": "The mathematical function that needs to be maximized or minimized. It represents the goal of the optimization, such as reducing cost or increasing profit."
  },
  {
    "id": 113,
    "topic_id": 5,
    "title": "What is the set of all possible solutions to an optimization problem called?",
    "description": "The feasible region."
  },
  {
    "id": 114,
    "topic_id": 5,
    "title": "True/False: The solution to an optimization problem often falls on the boundary of the feasible region.",
    "description": "True. The solution to an optimization problem often falls on the boundary of the feasible region because this is where the highest or lowest values of the objective function are usually found within the given constraints."
  },
  {
    "id": 115,
    "topic_id": 5,
    "title": "Does the one-armed bandit problem represent a constrained or unconstrained optimization problem?",
    "description": "This is an unconstrained problem because the game can be played an unlimited number of times."
  },
  {
    "id": 116,
    "topic_id": 5,
    "title": "What are the parameters that can be adjusted in an optimization problem called?",
    "description": "Decision variables."
  },
  {
    "id": 117,
    "topic_id": 5,
    "title": "What is the benefit of sensor fusion during image acquisition?",
    "description": "Sensor fusion combines data from multiple sources to create a more robust and accurate representation of the environment."
  },
  {
    "id": 118,
    "topic_id": 2,
    "title": "What are some common geometric transformations in image preprocessing?",
    "description": "Cropping, resizing, scaling, flipping, and rotating."
  },
  {
    "id": 119,
    "topic_id": 5,
    "title": "Gaussian blurring and median filtering are _________ techniques.",
    "description": "Noise reduction."
  },
  {
    "id": 120,
    "topic_id": 5,
    "title": "True/False: In color space conversion, colors are usually converted to the RGB scale.",
    "description": "False. In color space conversion, colors are not always converted to the RGB scale. Instead, they are often converted between various color spaces such as RGB, CMYK, and HSV, depending on the specific application and requirements."
  },
  {
    "id": 121,
    "topic_id": 5,
    "title": "What are some common features that can be extracted from images?",
    "description": "Edges, corners, blobs, ridges, and textures."
  },
  {
    "id": 122,
    "topic_id": 200,
    "title": "Explain the six phases of the CRISP-DM framework.",
    "description": "The six phases of the CRISP-DM framework are (1) define project objectives and requirements (business understanding), (2) collect and explore data to understand it (data understanding), (3) clean and construct datasets for analysis (data preparation), (4) apply modeling techniques to discover patterns (modeling), (5) assess the model to ensure it meets business objectives (evaluation), and (6) implement the model and monitor its performance (deployment)."
  },
  {
    "id": 123,
    "topic_id": 200,
    "title": "List some common applications of data science.",
    "description": "Prediction is used to forecast future events based on historical data. Pattern mining is used to identify hidden patterns and associations in data. Segmentation is used to group data into clusters based on shared characteristics. NLP enables machines to comprehend and generate human language. Signal processing is used to extract information from sensors and edge computing devices."
  },
  {
    "id": 124,
    "topic_id": 200,
    "title": "Explain the importance of clean code methods in data science projects.",
    "description": "Clean code methods ensure that code is maintainable, understandable, and efficient. It involves using meaningful variable and function names, keeping functions focused, adhering to a consistent coding style, handling bugs and errors gracefully, creating proper documentation, and unit test writing."
  },
  {
    "id": 125,
    "topic_id": 200,
    "title": "Understand the importance of compliance, security, and privacy to data science projects.",
    "description": "Compliance involves ensuring adherence to legal and regulatory standards relevant to data handling and processing. Security means protecting data from unauthorized access to maintain the integrity of the information. Privacy has to do with safeguarding data against misuse and ensuring that the rights of the data owner are respected in collection, storage, and usage."
  },
  {
    "id": 126,
    "topic_id": 200,
    "title": "Understand how the use of APIs enhances the deployment of data science models.",
    "description": "APIs enhance the deployment of data science models by exposing them as endpoints. This enables seamless integration with other applications or systems, enables multiple clients to access the same model simultaneously, facilitates the automation of data pipelines, and enhances the ease of maintenance."
  },
  {
    "id": 127,
    "topic_id": 200,
    "title": "Explain how derivatives are used in machine learning.",
    "description": "Derivatives are crucial for optimization, particularly in gradient descent, where they guide parameter updates to minimize the cost function. They're also used in backpropagation for neural network training and in finding optimal parameters in models like linear regression by solving for where the derivative of the cost function is 0."
  },
  {
    "id": 128,
    "topic_id": 200,
    "title": "Know the differences between how Euclidean, Manhattan, and cosine distance measures are used.",
    "description": "Euclidean distance is used for clustering and geometric data analysis. Manhattan distance is applied in grid-like structures and high-dimensional data. Cosine distance is primarily for text analysis and information retrieval, focusing on the orientation of vectors rather than their magnitude."
  },
  {
    "id": 129,
    "topic_id": 200,
    "title": "Explain how a probability density function (PDF), a cumulative distribution function (CDF), and a probability mass function (PMF) are used.",
    "description": "A probability density function (PDF) calculates probabilities for continuous variables. A cumulative distribution function (CDF) determines the likelihood of a variable falling within a specific range. A probability mass function (PMF) quantifies the probabilities of discrete outcomes."
  },
  {
    "id": 130,
    "topic_id": 200,
    "title": "List some common statistical tests and what they're used for.",
    "description": "Common statistical tests include the t-test for comparing means between two groups, ANOVA for comparing means among more than two groups, the chi-squared test for comparing observed and expected frequencies in categorical data, Pearson's correlation coefficient for measuring linear relationships, and Spearman's rank correlation coefficient for assessing monotonic relationships."
  },
  {
    "id": 131,
    "topic_id": 200,
    "title": "Explain what a confidence interval is and why it is used.",
    "description": "A confidence interval is a range of values that is likely to contain the true value of an estimated population parameter, based on a sample statistic. They are used to quantify the uncertainty of an estimate."
  },
  {
    "id": 132,
    "topic_id": 200,
    "title": "Explain the importance of data collection and storage in the data science lifecycle.",
    "description": "Effective data collection ensures that accurate, relevant, and diverse datasets are gathered, forming the basis for insightful, reliable analysis and prediction. Proper storage, on the other hand, guarantees data integrity, accessibility, and security, while also enabling efficient retrieval and processing."
  },
  {
    "id": 133,
    "topic_id": 200,
    "title": "Understand the differences between generated data, synthetic data, and commercial or public data.",
    "description": "Generated data comes from specific activities, like transactions or sensors; synthetic data is artificially created to mimic real data for testing or privacy; and commercial/public data is aggregated information released by organizations or governments for public or business use. Each type varies in source, purpose, and privacy considerations."
  },
  {
    "id": 134,
    "topic_id": 200,
    "title": "Identify which scenarios are best suited for generated data, synthetic data, and commercial or public data.",
    "description": "Generated data is best suited for real-time analysis, trend identification, and decision-making due to its immediacy and relevance. It's particularly beneficial in scenarios demanding high granularity and recurrence, such as longitudinal studies, detailed operational analyses, and real-time monitoring. Synthetic data is ideal when original data is scarce or confidential, or when creating training sets for machine learning models, especially in simulated environments or stress-testing scenarios. Commercial and public data is valuable when an organization's internal data is insufficient. It's used to supplement in-house data, providing additional insights for research, product development, or market analysis. Its usage often requires adherence to specific licensing agreements and restrictions."
  },
  {
    "id": 135,
    "topic_id": 200,
    "title": "Explain the difference between streaming and batch data ingestion.",
    "description": "Streaming data ingestion involves the continuous, real-time collection and processing of data, enabling immediate analysis and response to incoming information. This method is ideal for applications requiring instant insights or actions, such as fraud detection or real-time user behavior analysis. Conversely, batch data ingestion collects data in predefined segments or at scheduled intervals, processing it as a single unit. This approach is more cost-effective and suitable for scenarios without the need for immediate analysis, like for ingesting data into data warehouses or data lakes."
  },
  {
    "id": 136,
    "topic_id": 200,
    "title": "Describe the extract, transform, load process.",
    "description": "The ETL (extract, transform, load) process begins with the extraction of raw data from diverse sources like databases or cloud services. Next, the data undergoes transformation, where it is cleaned, validated, and enriched to meet specific business needs, ensuring it aligns with the destination's schema. The final step is loading the refined data into the target system for convenient access and analysis."
  },
  {
    "id": 137,
    "topic_id": 200,
    "title": "Identify which scenarios are best suited for structured, unstructured, or semi-structured storage.",
    "description": "Structured storage is ideal for organized, tabular data, commonly found in transactional systems. Unstructured storage, like filesystems and cloud object storage, is best suited for diverse data without a specific schema, such as documents and multimedia files. Semi-structured storage, which includes data stored in JSON and XML formats, caters to data that has an evolving structure or schema."
  },
  {
    "id": 138,
    "topic_id": 200,
    "title": "Describe the difference between a refresh cycle and archiving.",
    "description": "A refresh cycle is a scheduled update of data to maintain its accuracy, relevance, and currency. It is essential for informed decision-making, algorithm optimization, and data integrity. In contrast, archiving involves transferring data that's no longer actively used but needs to be retained to a more cost-effective, long-term storage platform. This process enhances operational efficiency by freeing up primary storage and ensuring compliance with data retention regulations."
  },
  {
    "id": 139,
    "topic_id": 200,
    "title": "Explain the importance of data exploration and analysis in the data science lifecycle.",
    "description": "Data exploration and analysis play a pivotal role in the data science lifecycle by enabling data scientists to gain valuable insights, uncover hidden patterns, and grasp the intrinsic properties of the data collected during the data collection and storage phase. It serves as an essential bridge between data acquisition and data modeling."
  },
  {
    "id": 140,
    "topic_id": 200,
    "title": "Understand the difference between quantitative and qualitative variables.",
    "description": "Quantitative or numerical variables are either discrete (with distinct values) or continuous (with infinite values within a range). Qualitative or categorical variables are nominal (with no inherent order), ordinal (with meaningful order), or binary (with only two outcomes)."
  },
  {
    "id": 141,
    "topic_id": 200,
    "title": "Explain univariate analysis and the best times to use it.",
    "description": "Univariate analysis is a simple form of exploratory data analysis where only one variable (univariate) is considered, focusing on describing the characteristics of that single variable through measures such as the mean, median, mode, range, variance, maximum, minimum, quartiles, and standard deviation. It is particularly useful when summarizing large datasets, identifying trends or patterns in one dimension, or simply presenting simplified data insights without the influence of other variables."
  },
  {
    "id": 142,
    "topic_id": 200,
    "title": "Explain bivariate analysis and the best times to use it.",
    "description": "Bivariate analysis involves the statistical examination of two variables (bivariate) to determine the empirical relationship between them, often visualized through scatterplots, line graphs, or correlation matrices. It is most effective when the goal is to understand the interactions between two variables\u2014for example, determining if a relationship is causal or coincidental, identifying trends, forecasting outcomes, or investigating hypotheses about underlying connections."
  },
  {
    "id": 143,
    "topic_id": 200,
    "title": "Explain multivariate analysis and the best times to use it.",
    "description": "Multivariate analysis examines more than two variables simultaneously to understand the relationships among them and their combined impact on outcomes. It is most useful when the goal is to understand interactions among multiple variables or to control for the influence of multiple variables on an outcome."
  },
  {
    "id": 144,
    "topic_id": 200,
    "title": "Describe how to identify common structural data quality issues.",
    "description": "Granularity misalignment can be detected by comparing the levels of detail across datasets. Outliers are identified using visual exploratory tools like box plots and scatterplots. Nonlinearity is identified through scatterplots or residual plots. Multicollinearity is detected using statistical measures like correlation matrices or VIF."
  },
  {
    "id": 145,
    "topic_id": 200,
    "title": "Describe how to identify common temporal data quality issues.",
    "description": "Identifying temporal data quality issues begins with visual inspection. For nonstationarity, plot the data to detect trends or seasonal effects, then use statistical tests like the Augmented Dickey\u2013Fuller (ADF) test to formally assess stationarity. For seasonality, visually inspect for cyclical behaviors and perform seasonal decomposition to statistically verify seasonality."
  },
  {
    "id": 146,
    "topic_id": 200,
    "title": "Describe how to identify common completeness data quality issues.",
    "description": "Identifying completeness data quality issues requires different approaches. For the issue of insufficient features, we can suspect that this issue is at play when model performance doesn't improve in spite of extensive tuning. The issue of data sparsity is identified by quantifying the proportion of missing or zero values in the data. Missing data is detected through preliminary data analysis or visualization techniques such as heatmaps or missing data plots."
  },
  {
    "id": 147,
    "topic_id": 200,
    "title": "Explain the importance of data processing and preparation in the data science lifecycle.",
    "description": "Data processing and preparation is a foundational stage in the data science lifecycle that directly impacts the quality of insights derived. It involves transforming raw, messy data into structured, clean, enriched, and balanced data. Without proper data processing and preparation, even the most advanced algorithms and models would struggle to produce accurate, reliable, and meaningful results."
  },
  {
    "id": 148,
    "topic_id": 200,
    "title": "Understand how encoding, scaling, normalization, transformation functions, and structural transformation are used for data transformation.",
    "description": "Encoding converts categorical data into numerical form, with techniques like one-hot encoding and label encoding. Scaling and normalization adjust the scales of numerical features for consistency, using methods like min-max normalization and standardization. Transformation functions like log transformation and Box-Cox transformation reshape data to meet algorithm assumptions or improve model performance, addressing issues like skewness or nonlinearity. Structural transformation techniques like binning, pivoting, and flattening are used to make data more suitable for specific analytical or visualization purposes."
  },
  {
    "id": 149,
    "topic_id": 200,
    "title": "Explain when to use a union, intersection, or join operation.",
    "description": "Union, intersection, and join operations serve distinct purposes in data manipulation: Union combines datasets with the same structure into one, useful for aggregating similar data from different sources; intersection identifies common records between datasets, ideal for finding exact similarities across different groups; and joins merge datasets based on a key, crucial for retrieving interconnected data from separate tables in a database. The choice among them hinges on the layout of your data and your analytical goals\u2014whether to aggregate, find commonalities, or explore relationships within your data."
  },
  {
    "id": 150,
    "topic_id": 200,
    "title": "Understand the difference between idiosyncratic and systemic errors.",
    "description": "Idiosyncratic errors are random and unpredictable, with no fixed pattern, often arising from isolated mishaps or unforeseen glitches. Systematic errors, however, are uniform and recur consistently, usually due to an inherent bias or flaw in the data-gathering process. The key distinction lies in the nature of their occurrence: although idiosyncratic errors are sporadic and diminish in larger datasets, systematic errors present a consistent deviation, posing a continuous threat to data integrity unless specifically identified and corrected."
  },
  {
    "id": 151,
    "topic_id": 200,
    "title": "Explain how to handle inconsistent data, duplicate data, missing data, and outlier data.",
    "description": "Resolving inconsistencies requires standardizing formats and measurements; duplicate entries must be identified and either merged or purged; missing data calls for methods ranging from deletion to sophisticated imputation techniques, depending on the context and data type; and outliers necessitate careful scrutiny, with responses varying from removal to statistical adjustments, all depending on whether they represent true data points or anomalies. Each approach demands a nuanced understanding of the nature of the data and the intended analysis."
  },
  {
    "id": 152,
    "topic_id": 200,
    "title": "Understand what class imbalance is and how to handle it.",
    "description": "Class imbalance in supervised machine learning arises when there's a disparity between class examples in training data, affecting model performance and metric reliability. Addressing this involves gathering more data for the minority class, adopting metrics like precision and recall instead of mere accuracy, utilizing algorithms less sensitive to imbalance, and resampling data through methods like undersampling (reducing majority class instances) and oversampling (increasing minority class instances or generating synthetic ones). Properly implementing these strategies can enhance model effectiveness on imbalanced datasets."
  },
  {
    "id": 153,
    "topic_id": 200,
    "title": "Understand the difference between regressors and classifiers.",
    "description": "The key difference lies in the nature of the output. Regressors are designed to predict continuous values, such as stock prices, whereas classifiers are used to assign categorical class labels to observations, like distinguishing between spam and non-spam emails."
  },
  {
    "id": 154,
    "topic_id": 200,
    "title": "Explain the differences between time-series analysis, survival analysis, and a longitudinal study.",
    "description": "The main differences are that time-series analysis is used to predict future values from historical data patterns, survival analysis is used to estimate the time until an event, and longitudinal studies allow us to observe the same subjects over time."
  },
  {
    "id": 155,
    "topic_id": 200,
    "title": "Understand how cross-validation, bootstrapping, hyperparameter tuning, and feature selection minimize variance.",
    "description": "Cross-validation and bootstrapping both reduce variance by evaluating model performance across different data subsets. Hyperparameter tuning reduces variance by optimizing model settings to generalize well. Feature selection prevents overfitting by retaining only relevant predictors. Together, these techniques enhance a model's predictive performance and generalizability to new, unseen data."
  },
  {
    "id": 156,
    "topic_id": 200,
    "title": "Explain the difference between R-squared and adjusted R-squared.",
    "description": "In a linear regression model, R-squared is the proportion of variance in the dependent variable explained by the independent variables. Adjusted R-squared modifies R-squared to account for the number of independent variables in the model. It increases only if the addition of a new variable enhances the model significantly."
  },
  {
    "id": 157,
    "topic_id": 200,
    "title": "Explain the difference between Akaike information criterion (AIC) and Bayesian information criterion (BIC).",
    "description": "The Akaike information criterion (AIC) and Bayesian information criterion (BIC) are both used for model selection. BIC, while similar to AIC, adds a stronger penalty for models with more parameters. BIC favors simpler models and is better when overfitting is a concern or model interpretability is important."
  },
  {
    "id": 158,
    "topic_id": 200,
    "title": "Know the difference between precision and recall.",
    "description": "Precision is the proportion of true positives among all positive predictions made by the model, whereas recall is the proportion of actual positives correctly identified by the model. Both metrics are crucial for understanding a model's performance on the positive class."
  },
  {
    "id": 159,
    "topic_id": 200,
    "title": "Know the difference between sensitivity and specificity.",
    "description": "Sensitivity, which is synonymous with recall, measures a model's ability to correctly identify positive cases, while specificity measures how well a model identifies the negatives cases. Together, they offer a balanced view of a model's ability to classify both positive and negative cases accurately."
  },
  {
    "id": 160,
    "topic_id": 200,
    "title": "Describe how to use the receiver operating characteristic (ROC) curve to evaluate model performance.",
    "description": "When choosing between models using the ROC curve, you should typically choose the model whose ROC curve is closest to the top left corner of the plot. This represents the highest true positive rate (sensitivity) with the lowest false positive rate (1-specificity). Also, the model with the largest area under the ROC curve (AUC) is often considered the best, as it indicates the model that has a better overall performance across all classification thresholds."
  },
  {
    "id": 161,
    "topic_id": 200,
    "title": "Understand the importance of design constraints, performance evaluation, and requirements validation during model design.",
    "description": "Design constraints evaluate the viability of a model by assessing whether it fits within time, resource, and cost limits. Performance evaluation uses statistical metrics to assess the model's effectiveness. Requirements validation aligns the model with business needs, confirming it meets stakeholder expectations and fulfills core objectives."
  },
  {
    "id": 162,
    "topic_id": 200,
    "title": "Explain how benchmarking is used to justify model selection.",
    "description": "Benchmarking justifies model selection by comparing a new model's performance against a baseline, such as an existing model or industry standard, to determine if it offers significant improvements. It also compares the model to conventional processes to assess if it provides tangible benefits, like improved operational efficiency or decision making, which are critical for stakeholder acceptance."
  },
  {
    "id": 163,
    "topic_id": 200,
    "title": "Know the key concepts to consider when communicating model results.",
    "description": "When you're communicating model results, key concepts to consider include selecting relevant data that supports the core message, using appropriate visualizations to elucidate the model's insights, tailoring the communication to the audience's level of expertise, ensuring ethical reporting standards, designing for accessibility, and providing comprehensive documentation for transparency and credibility."
  },
  {
    "id": 164,
    "topic_id": 200,
    "title": "Know the differences between cloud, on-premises, hybrid, and edge deployment.",
    "description": "Cloud deployment involves using Internet-hosted server resources. On-premises deployment is where services are deployed within an organization's local infrastructure. Hybrid deployment combines cloud and on-premises deployment strategies. Edge deployment places resources closer to the source of data to minimize latency."
  },
  {
    "id": 165,
    "topic_id": 200,
    "title": "Explain the importance of MLOps principles in data science.",
    "description": "MLOps principles are critical in data science because they provide a framework for consistent, efficient, and scalable machine learning workflows, bridging the gap between experimental development and operational deployment. MLOps fosters automation, rigorous testing, version control, and monitoring, which are all essential for the long-term success and governance of data science projects."
  },
  {
    "id": 166,
    "topic_id": 200,
    "title": "Explain how support, confidence, and lift are used to evaluate the strength of an association rule.",
    "description": "Respectively, support, confidence, and lift evaluate association rules by measuring rule frequency, predictive strength, and the likelihood of items being purchased together versus separately. High support and confidence, along with a lift greater than 1, indicate a strong, non-random association between items."
  },
  {
    "id": 167,
    "topic_id": 200,
    "title": "Understand the difference between centroid-based, connectivity-based, and density-based clustering.",
    "description": "Centroid-based clustering, such as k-means, groups data points around a central point or centroid within the cluster. Connectivity-based clustering, like hierarchical clustering, creates a tree of clusters based on the proximity of data points. Density-based clustering, exemplified by DBSCAN, forms clusters in regions of high density, separated by areas of low density, and can detect clusters of arbitrary shapes."
  },
  {
    "id": 168,
    "topic_id": 200,
    "title": "Know the difference between feature selection and feature extraction.",
    "description": "Feature selection involves choosing a subset of the most significant features from the original data, whereas feature extraction creates new features by transforming or combining the original features into a lower-dimensional space."
  },
  {
    "id": 169,
    "topic_id": 200,
    "title": "Understand when it's best to use linear and nonlinear dimensionality reduction techniques.",
    "description": "Linear dimensionality reduction is suitable for datasets with linear correlations among features, where preserving global structure is important. Techniques like PCA and SVD are effective for this. Nonlinear dimensionality reduction is ideal for complex datasets where data forms manifolds or clusters not separable by a linear boundary. Techniques like t-SNE or UMAP are best for these."
  },
  {
    "id": 170,
    "topic_id": 200,
    "title": "Explain the difference between collaborative filtering and content-based filtering.",
    "description": "Collaborative filtering makes recommendations by identifying patterns in user interactions, assuming users with similar behaviors have similar preferences. Content-based filtering, on the other hand, recommends items using the characteristics of the items themselves and a user's previous choices."
  },
  {
    "id": 171,
    "topic_id": 200,
    "title": "Explain the difference between LASSO, ridge, and ElasticNet regularization.",
    "description": "LASSO uses L1 regularization, which adds a penalty equal to the absolute value of the magnitude of coefficients, leading to feature selection. Ridge regression employs L2 regularization, adding a penalty equal to the square of the magnitude of coefficients, causing them to shrink but not zero out. ElasticNet combines both L1 and L2 regularization, balancing feature selection and coefficient shrinkage, and is effective when predictors are correlated."
  },
  {
    "id": 172,
    "topic_id": 200,
    "title": "Understand the similarities between logistic regression, linear discriminant analysis, and quadratic discriminant analysis.",
    "description": "Logistic regression, linear discriminant analysis (LDA), and quadratic discriminant analysis (QDA) are all used for classification. Logistic regression and LDA are particularly similar in their use of linear decision boundaries, although logistic regression is primarily used for binary classification, whereas LDA extends to multiclass problems. QDA, an extension of LDA, also focuses on classification but allows for more complex, nonlinear decision boundaries."
  },
  {
    "id": 173,
    "topic_id": 200,
    "title": "Know the key benefits and limitations of naive Bayes.",
    "description": "Naive Bayes, known for its simplicity and efficiency, excels in handling high-dimensional data and is less prone to overfitting. Its probabilistic nature provides clear insights into prediction certainty, and it copes well with missing data. However, its key limitation is the assumption of class conditional independence among predictors, which is often unrealistic in real-world data."
  },
  {
    "id": 174,
    "topic_id": 200,
    "title": "Know the key benefits and limitations of decision trees.",
    "description": "Decision trees are favored for their interpretability and simplicity. They are capable of capturing nonlinear relationships and handling both numerical and categorical data with minimal preprocessing. They translate well into understandable rules, aiding transparent decision making. However, they are prone to overfitting, which can be mitigated through pruning. They're sensitive to small data changes and can perform poorly on imbalanced datasets."
  },
  {
    "id": 175,
    "topic_id": 200,
    "title": "Explain the difference between bagging, boosting, and stacking ensembles.",
    "description": "Bagging involves training multiple homogenous models independently, which reduces variance. Boosting involves sequentially training homogenous models, where each model learns from the errors of the previous one. It improves accuracy but also increases the risk of overfitting. Stacking trains multiple heterogenous models and then combines their predictions using a meta-learner."
  },
  {
    "id": 176,
    "topic_id": 200,
    "title": "Explain the difference between the input, hidden, and output layers of a neural network.",
    "description": "In a neural network, the input layer receives and passes on raw data without change. The hidden layers perform complex computations and feature extraction. The output layer presents the final results of the network."
  },
  {
    "id": 177,
    "topic_id": 200,
    "title": "Know what an activation function is and list some of the commonly used activation functions.",
    "description": "Activation functions in a neural network transformed combined input signals into a single output signal, normalizing outputs to a manageable scale and introducing nonlinearity, which enables complex pattern modeling. Common activation functions include sigmoid, hyperbolic tangent, rectified linear unit, and softmax."
  },
  {
    "id": 178,
    "topic_id": 200,
    "title": "Explain some of the strategies used to improve the training efficiency of a neural network.",
    "description": "Techniques used include dropout (to prevent overfitting by randomly deactivating nodes), batch normalization (to stabilize and accelerate training by normalizing inputs), early stopping (to halt training when validation performance degrades), and learning rate schedulers (to adjust the learning rate for better convergence)."
  },
  {
    "id": 179,
    "topic_id": 200,
    "title": "Understand what a deep neural network is and list some of the common architectures.",
    "description": "A deep neural network is a multilayered network with several hidden layers that enable complex, high-level feature extraction. Common architectures include convolutional neural networks (CNNs) for grid-like data, recurrent neural networks (RNNs) and long short-term memory (LSTMs) for sequential data, transformers for natural language processing, generative adversarial networks (GANs) for content generation, and autoencoders for unsupervised learning tasks like dimensionality reduction."
  },
  {
    "id": 180,
    "topic_id": 200,
    "title": "Explain the difference between string matching and semantic matching.",
    "description": "String matching compares texts based on lexical or syntactic similarity, focusing on exact structure or composition. Semantic matching compares texts based on underlying meaning, considering context and semantic content. String matching is used for tasks like spell checking and plagiarism detection, whereas semantic matching is used in search engines and question-answering systems."
  },
  {
    "id": 181,
    "topic_id": 200,
    "title": "Know what sentiment analysis is used for.",
    "description": "Sentiment analysis is used to identify and categorize emotions or opinions in text, determining attitudes toward topics, products, or services. It has applications in business for customer feedback analysis, in politics for public opinion tracking, and in social media for monitoring brand reputation and user sentiments."
  },
  {
    "id": 182,
    "topic_id": 200,
    "title": "Explain topic modeling and its use.",
    "description": "Topic modeling is used to discover thematic structures in large text collections, aiding in understanding and organizing textual information. It enhances information retrieval, reveals trends and patterns, and supports recommender systems by recommending content based on topics of interest."
  },
  {
    "id": 183,
    "topic_id": 200,
    "title": "Understand the importance and key aspects of text preparation.",
    "description": "Text preparation involves a series of steps used to extract meaningful information and reduce the complexity of raw text data in order to make it more suitable for NLP tasks and model training. Common text preparation steps include tokenization, stemming, lemmatization, removal of stop words, part-of-speech tagging, spelling normalization, and data augmentation."
  },
  {
    "id": 184,
    "topic_id": 200,
    "title": "Explain TF-IDF and its use.",
    "description": "TF-IDF (term frequency-inverse document frequency) is a weighting scheme used in text representation to measure the importance of a word within a document relative to its frequency across a corpus. High TF-IDF indicates a word is important and frequent in a specific document but rare across the entire corpus, whereas low TF-IDF suggests the word is either common across documents or infrequent in the document."
  },
  {
    "id": 185,
    "topic_id": 200,
    "title": "Understand what word embeddings are and why they are useful.",
    "description": "Word embeddings represent words as dense vectors in a high-dimensional space, capturing semantic similarity based on vector proximity. They are useful for encoding linguistic relationships, which enhance the performance of NLP tasks such as text classification, sentiment analysis, and language translation."
  },
  {
    "id": 186,
    "topic_id": 200,
    "title": "Explain how decision variables, objective functions, and constraints are used in optimization.",
    "description": "Decision variables represent parameters that can be adjusted to achieve a desired outcome. The objective function quantifies the goal of the optimization. Constraints are limitations or requirements that the solution must satisfy."
  },
  {
    "id": 187,
    "topic_id": 200,
    "title": "Know the difference between linear and nonlinear programming.",
    "description": "Linear programming problems are constrained optimization problems where both the objective function and constraints are linear. Nonlinear programming problems are constrained optimization problems where either the objective function or the constraints are nonlinear."
  },
  {
    "id": 188,
    "topic_id": 200,
    "title": "Explain the difference between constrained and unconstrained optimization.",
    "description": "Constrained optimization involves finding the optimal solution of an objective function subject to a set of constraints, such as equality or inequality conditions. Unconstrained optimization seeks the maximum or minimum of an objective function without any restrictions or constraints on the decision variables, except those inherent in the function's domain."
  },
  {
    "id": 189,
    "topic_id": 200,
    "title": "List some common applications of computer vision.",
    "description": "Some common applications of computer vision include autonomous vehicles, facial recognition, medical imaging, augmented reality, optical character recognition, object detection and recognition, image segmentation, and motion analysis and object tracking."
  },
  {
    "id": 190,
    "topic_id": 200,
    "title": "Explain why image preprocessing is useful in computer vision.",
    "description": "Image preprocessing enhances image quality and prepares data for analysis, improving the reliability of feature extraction and the performance of computer vision algorithms. It involves tasks such as geometric transformation, noise reduction, contrast enhancement, normalization, color space conversion, and hole filling."
  }
];
